<template>
  <v-dialog persistent v-model="devicesInfoForDeleteLicence" width="480">
    <div class="ec-dialog">
      <div class="ec-dialog__header">
        <div>
          <h2 class="ec-dialog__title">Notice about Devices</h2>
          <p class="ec-hint" style="margin:2px 0 0">{{ licenceForDevicesInfo.label }}</p>
        </div>
      </div>

      <div class="ec-dialog__body" style="padding:0">
        <div class="difd-warning">
          <v-icon color="var(--ec-danger)" size="18" style="margin-right:8px;flex-shrink:0">mdi-alert</v-icon>
          <span>If this licence is deleted, it will be removed from the devices listed below.</span>
        </div>

        <div class="difd-section-label">Devices List</div>

        <div class="difd-device-list">
          <div
            v-for="item in licenceForDevicesInfo.devices"
            :key="item.id"
            class="difd-device-row"
          >
            <v-icon size="14" style="color:var(--ec-text-3);flex-shrink:0">mdi-cellphone-link</v-icon>
            <div class="difd-device-info">
              <span class="difd-device-name">{{ item.device_client_name }}</span>
              <span class="difd-device-meta">{{ item.device_label }} | {{ item.created_at }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="ec-dialog__footer">
        <button class="ec-btn ec-btn--ghost" type="button" @click="closeDevicesInfoForDeleteLicence">Cancel</button>
        <button class="ec-btn" style="background:var(--ec-danger);color:#fff;border-color:var(--ec-danger)" type="button" @click="deleteLicence">
          <v-icon size="14" style="margin-right:5px">mdi-delete-outline</v-icon>
          Keep Deleting
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import converter from '../../mixins/converter'
import { apiService } from '../../service/api.service'
export default {
  data: () => ({
    menu: false,
    labels: ['SU', 'MO', 'TU', 'WED', 'TH', 'FR', 'SA'],
    time: 0,
    forecast: [
      { day: 'Tuesday', icon: 'mdi-white-balance-sunny', temp: '24\xB0/12\xB0' },
      { day: 'Wednesday', icon: 'mdi-white-balance-sunny', temp: '22\xB0/14\xB0' },
      { day: 'Thursday', icon: 'mdi-cloud', temp: '25\xB0/15\xB0' }
    ]
  }),
  mixins: [converter],
  props: {
    devicesInfoForDeleteLicence: { type: Boolean, default: false },
    licenceForDevicesInfo: { type: Object, required: true },
    licenceName: { type: String, default: '' }
  },
  methods: {
    closeDevicesInfoForDeleteLicence () {
      this.$emit('closeDevicesInfoForDeleteLicence')
    },
    async deleteLicence () {
      const deleteLicencePayload = {
        user_id: this.licenceForDevicesInfo.user_id,
        licence_id: this.licenceForDevicesInfo.id
      }
      await apiService
        .post('admin-delete-permanently-user-licence', deleteLicencePayload)
        .then(() => {
          this.$emit('callSyncUserLicences')
          this.closeDevicesInfoForDeleteLicence()
        })
        .catch((err) => {
          console.error('Delete licence failed', err)
        })
    }
  }
}
</script>

<style scoped>
.difd-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 20px;
  background: var(--ec-danger-bg);
  border-bottom: 1px solid #fecaca;
  font-size: .82rem;
  color: var(--ec-danger);
}

.difd-section-label {
  padding: 10px 20px 6px;
  font-size: .7rem;
  font-weight: 700;
  letter-spacing: .05em;
  text-transform: uppercase;
  color: var(--ec-text-3);
  border-bottom: 1px solid var(--ec-border-light);
}

.difd-device-list {
  max-height: 260px;
  overflow-y: auto;
}
.difd-device-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--ec-border-light);
  transition: background .12s;
}
.difd-device-row:last-child { border-bottom: none; }
.difd-device-row:hover { background: var(--ec-bg); }
.difd-device-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.difd-device-name {
  font-size: .84rem;
  font-weight: 600;
  color: var(--ec-text-1);
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.difd-device-meta {
  font-size: .72rem;
  color: var(--ec-text-3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
